import _ from "lodash";
import {
  handleChangeActionType,
  handleChangeAllActionType,
  handleChangeToInitStateActionType,
} from "../../actions/handleChangeAction";

const INITIAL_STATE = {
  fraDato: "",
  tilDato: "",
  selectedIleggelsestyper: [],
  brukerepost: "",
  fraDatoValidationErrorText: null,
  fraTidValidationErrorText: null,
  tilDatoValidationErrorText: null,
  tilTidValidationErrorText: null,
  brukerepostValidationErrorText: null,
};

export default function rapportJuridiskSaksbehandlerFilterFormReducer(
  state = {
    ...INITIAL_STATE,
    validationError: { ...INITIAL_STATE.validationError },
  },
  action,
) {
  switch (action.type) {
    case handleChangeActionType("RAPPORT_JURIDISK_SAKSBEHANDLER_FILTER_FORM"):
      _.set(state, action.variableName, action.payload);
      return { ...state };
    case handleChangeAllActionType(
      "RAPPORT_JURIDISK_SAKSBEHANDLER_FILTER_FORM",
    ):
      return { ...action.payload };
    case handleChangeToInitStateActionType(
      "RAPPORT_JURIDISK_SAKSBEHANDLER_FILTER_FORM",
    ):
      return {
        ...INITIAL_STATE,
        validationError: { ...INITIAL_STATE.validationError },
      };
    default:
      return state;
  }
}
